import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject } from 'vue';

import { InputStep, Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { PortfolioSelectionBox } from './components/PortfolioSelectionBox';

import { ESuggestedPortfolioBuilderSteps } from '@/modules/wealth/views/SuggestedPortfolioBuilder/helpers';
import {
  IWallet,
  IRisk
} from '@/modules/wealth/services/suggested-portfolio-builder';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioSelect',
  setup(__props) {

const changeStep = inject(
  'changeStep',
  (step: ESuggestedPortfolioBuilderSteps) => ({ step })
);
const savePortfolio = inject('savePortfolio', (portfolioId: string) => ({
  portfolioId
}));

const injectSuggestedPortfolios = inject('suggestedPortfolios') as IWallet[];

const suggestedPortfolios = ref(injectSuggestedPortfolios);

const suggestedPortfolio = computed(() => {
  return suggestedPortfolios.value.find(
    portfolio => portfolio.isSuggestedInvestment
  );
});

const otherSuggestionsTitle = computed(() => {
  return suggestedPortfolio.value?.risk === IRisk.LOW
    ? 'Outras opções compatíveis'
    : 'Opções de menor risco';
});

const otherSuggestedPortfolios = computed(() => {
  return suggestedPortfolios.value.filter(
    portfolio => !portfolio.isSuggestedInvestment
  );
});

function handleClick(data: IWallet) {
  savePortfolio(data.apiId);
}

function onBack() {
  changeStep(ESuggestedPortfolioBuilderSteps.GOAL_DATE);
}

return { __sfc: true,changeStep, savePortfolio, injectSuggestedPortfolios, suggestedPortfolios, suggestedPortfolio, otherSuggestionsTitle, otherSuggestedPortfolios, handleClick, onBack, InputStep, Heading, BaseText, NebraskaColors, PortfolioSelectionBox }
}

})